import { render, staticRenderFns } from "./ProductInfomration.vue?vue&type=template&id=c7442608&scoped=true&"
import script from "./ProductInfomration.vue?vue&type=script&lang=js&"
export * from "./ProductInfomration.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfomration.vue?vue&type=style&index=0&id=c7442608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7442608",
  null
  
)

export default component.exports